import React, { useEffect } from 'react';
import Intercom, { update } from '@intercom/messenger-js-sdk';
import Deposit from '.';
import { useSession } from '@/contexts/LitSessionProvider';
import SlidingModal from '../home/mobile/SlidingModal';
import useGetUserProfileInfo from '@/hooks/auth/useGetUserProfileInfo';
import usePaymentProvider from '@/hooks/deposit/usePaymentProvider';
export default function MobileDeposit({
  isModalOpen,
  setIsModalOpen
}) {
  const {
    selectedPaymentMethod,
    setSelectedPaymentMethod
  } = usePaymentProvider();
  const {
    PKP
  } = useSession();
  function toggleModal() {
    setIsModalOpen(!isModalOpen);
    setSelectedPaymentMethod(null);
  }
  useEffect(() => {
    if (!PKP) return;
    Intercom({
      app_id: 'ei6xmnio',
      user_id: PKP?.username,
      // IMPORTANT: Replace "user.id" with the variable you use to capture the user's ID
      name: PKP?.firstName,
      // IMPORTANT: Replace "user.name" with the variable you use to capture the user's name
      email: PKP?.email // IMPORTANT: Replace "user.email" with the variable you use to capture the user's email
    });
    update({
      hide_default_launcher: true
    });
  }, [PKP]);
  return <SlidingModal isOpen={isModalOpen} onClose={toggleModal} heightFit={true} data-sentry-element="SlidingModal" data-sentry-component="MobileDeposit" data-sentry-source-file="MobileDeposit.tsx">
      <Deposit data-sentry-element="Deposit" data-sentry-source-file="MobileDeposit.tsx" />
    </SlidingModal>;
}